<script type="text/ecmascript-6">

    export default {
        props: {
            status: {
                'type': Object,
                'required': true
            }
        },

        computed: {
            connectionCounts: function() {
                return _.mapValues(this.status.connections, function(connection) {
                    return _.reduce(connection.queues, function(sum, queue) {
                        return sum + queue.count;
                    }, 0);
                });
            },
            countAll: function() {
                return _.reduce(this.connectionCounts, function(sum, countPerConnection) {
                    return sum + countPerConnection;
                }, 0);
            }
        },

        methods: {

            openQueue: function () {
                window.location.href = window.Scoop.baseUrl + '/scoop/queue';
            }
        }
    }
</script>
<template>
    <li id="queue-status-widget" v-if="countAll > 0" class="dropdown">
        <a href="#" data-toggle="dropdown" class="dropdown-toggle count-info" aria-expanded="true">
            <i class="fa fa-spin fa-cog"></i>
            <span class="label label-primary" v-text="countAll"></span>
        </a>
        <ul class="dropdown-menu dropdown-alerts">
            <template v-for="connection in status.connections">
                <template v-for="queue in connection.queues">
                    <template v-if="queue.count > 0">
                        <li>
                            <a @click="openQueue">
                                <div>
                                    <span class="pull-right text-muted small" v-text="queue.count"></span>
                                    <i class="fa fa-fw" :class="'fa-'+queue.icon"></i> <span v-html="queue.label"></span>
                                    <br>
                                    <small class="text-muted" v-text="connection.label"></small>
                                </div>
                            </a>
                        </li>
                        <li class="divider"></li>
                    </template>
                </template>
            </template>
            <li>
                <div class="text-center link-block">
                    <a @click="openQueue">
                        <strong>Detailed queue status</strong>
                        <i class="fa fa-angle-right"></i>
                    </a>
                </div>
            </li>
        </ul>
    </li>
</template>
<style>
</style>